<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>
<main class="container py-4">
  <div class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
    <div>
      <h3 class="fw-bold mb-1">Compliance Review Queue</h3>
      <p class="text-muted mb-0">Review user KYC applications, start assessment, approve, or reject.</p>
    </div>
  </div>

  <div class="card border-0 shadow-sm mb-3">
    <div class="card-body">
      <div class="row g-2">
        <div class="col-md-3">
          <input class="form-control" [(ngModel)]="filter.search" placeholder="Search name, email, phone..." />
        </div>
        <div class="col-md-2">
          <select class="form-select" [(ngModel)]="filter.jurisdictionCode">
            <option value="">All</option>
            <option *ngFor="let j of jurisdictions" [value]="j.code">{{ j.code }} - {{ j.name }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <select class="form-select" [(ngModel)]="filter.tierCode">
            <option value="">All</option>
            <option *ngFor="let x of tierCodes" [value]="x.value">{{ x.label }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <select class="form-select" [(ngModel)]="filter.status">
            <option value="">All</option>
            <option *ngFor="let x of statuses" [value]="x.label">{{ x.label }}</option>
          </select>
        </div>
        <div class="col-md-3 d-flex gap-2">
          <button class="btn btn-primary btn-sm" (click)="filter.page = 1; load()">Apply</button>
          <button class="btn btn-outline-secondary btn-sm" (click)="filter = { status: '', jurisdictionCode: '', tierCode: '', customerType: '', productType: '', search: '', page: 1, pageSize: 20 }; load()">Reset</button>
        </div>
      </div>
    </div>
  </div>

  <div class="card border-0 shadow-sm">
    <div class="card-body p-0">
      <div *ngIf="loading" class="p-4 text-center text-muted">Loading review queue...</div>
      <div class="table-responsive" *ngIf="!loading">
        <table class="table table-hover align-middle mb-0">
          <thead>
            <tr>
              <th>User</th>
              <th>Jurisdiction</th>
              <th>Tier</th>
              <th>Status</th>
              <th>Product</th>
              <th>Submitted</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items">
              <td>
                <div class="fw-semibold">{{ item.fullName || 'N/A' }}</div>
                <div class="small text-muted">{{ item.email }}</div>
              </td>
              <td>{{ item.jurisdictionCode }}</td>
              <td>{{ item.tierCode }}</td>
              <td><span class="badge text-bg-light border">{{ item.status }}</span></td>
              <td>{{ item.productType }}</td>
              <td>{{ (item.submittedAt || item.startedAt) | date:'mediumDate' }}</td>
              <td class="text-end">
                <div class="d-inline-flex flex-wrap gap-2 justify-content-end">
                  <button class="btn btn-outline-secondary btn-sm" (click)="open(item)">View</button>
                  <button class="btn btn-outline-primary btn-sm" *ngIf="item.status === 'Submitted'" (click)="startReview(item)">Start Review</button>
                  <button class="btn btn-outline-success btn-sm" *ngIf="item.status === 'UnderReview'" (click)="approve(item)">Approve</button>
                  <button class="btn btn-outline-danger btn-sm" *ngIf="item.status === 'UnderReview' || item.status === 'Submitted'" (click)="reject(item)">Reject</button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!items.length">
              <td colspan="7" class="text-center text-muted py-4">No applications found.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <app-pagination [url]="'/admin/compliance/reviews'" [counts]="meta" (refresh)="filter.page = $event; load()"></app-pagination>
    </div>
  </div>

        <app-footer></app-footer>
</main>
</div>
